export default __webpack_public_path__ + "static/media/elementos-ilustracion-3.e9132ddf.svg";